//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RiskAssessment',
  data () {
    return {
      form: {
        age: '',
        graves: '',
        trab: '',
        thyroid: '',
        ohd: '',
        knowthyroid: '',
        llength: '',
        lheight: '',
        lwidth: '',
        rlength: '',
        rheight: '',
        rwidth: '',
        ft4: ''
      },
      risk: '',
      reappear: '',
      dataList7: [
        { value: '0', name: '<40pmol/L(<31pg/ml)' },
        { value: '1', name: '≥40pmol/L(≥31pg/ml)' }
      ],
      dataList2: [
        { value: '0', name: '无' },
        { value: '48', name: '有' }
      ],
      dataList3: [
        { value: '0', name: '＜13U/L' },
        { value: '57', name: '≥13U/L' }
      ],
      dataList4: [
        { value: '0', name: '0°~1°' },
        { value: '34', name: 'II°~III°' }
      ],
      dataList5: [
        { value: '0', name: '≥14.7ng/mL' },
        { value: '40', name: '<14.7ng/mL' },
        { value: '2', name: '未知' }
      ],
      dataList6: [
        { value: '0', name: '未知' },
        { value: '1', name: '知晓' }
      ],
      hasScore: false,
      disabled: false,
      descTxt: '',
      modelTxt: '',
      suggestTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      let risk = ''
      let reappear = ''
      let result = 0
      let volume = 0
      // 逻辑一
      if (form.ohd !== 2 && form.knowthyroid === 1) {
        volume =
          (0.479 *
            (form.llength * form.lwidth * form.lheight +
              form.rlength * form.rwidth * form.rheight)) /
          1000
        if (volume > 26.4 || volume === 26.4) {
          risk =
            form.age < 30
              ? 30
              : 0 + form.graves + form.trab < 13
                ? 0
                : 57 + form.thyroid + form.ohd + 100
        } else {
          risk =
            form.age < 30
              ? 30
              : 0 + form.graves + form.trab < 13
                ? 0
                : 57 + form.thyroid + form.ohd
        }
        result = risk
        if (risk >= 3 && risk <= 56) {
          reappear = '10%~20%'
        } else if (risk > 56 && risk < 90) {
          reappear = '20%~29%'
        } else if (risk === 90) {
          reappear = '30%'
        } else if (risk > 90 && risk < 116) {
          reappear = '31%~40% '
        } else if (risk > 116 && risk < 136) {
          reappear = '41%~50%'
        } else if (risk > 136 && risk < 156) {
          reappear = ' 51%~60%'
        } else if (risk > 156 && risk < 176) {
          reappear = '61%~70%'
        } else if (risk > 176 && risk < 196) {
          reappear = '71%~80%'
        } else if (risk > 196 && risk < 221) {
          reappear = ' 81%~90%'
        } else if (risk > 220) {
          reappear = ' 90%'
        }
      }

      // 逻辑二
      if (form.knowthyroid === 0) {
        let trab = 0
        if (form.trab < 6) {
          trab = 0
        } else if (form.trab >= 20) {
          trab = 2
        } else {
          trab = 1
        }
        result = (form.age < 40 ? 1 : 0) + trab + (form.thyroid === 0 ? 0 : 2) + form.ft4
        if (result < 2) {
          risk = 'I级'
          reappear = '16.4％'
        } else if (result === 2 || result === 3) {
          risk = 'Ⅱ级'
          reappear = '43.9％'
        } else if (result === 4 || result === 5 || result === 6) {
          risk = 'Ⅲ级'
          reappear = '68.4％'
        }
      }
      self.risk = risk
      self.reappear = reappear
      self.hasScore = true
      return {
        volume: String(volume.toFixed(2)) + 'cm³',
        score: String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/RiskAssessment.vue